import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '@/lib/api-fetch';
import type { FeedbackDocument } from '@syfo/types/feedback.types';

interface SubmitFeedbackParams {
  feedback: FeedbackDocument;
}

interface SubmitFeedbackResponse {
  message: string;
  timestamp: string;
}

/**
 * Submit feedback to the server
 */
export const submitFeedbackThunk = createAsyncThunk<
  SubmitFeedbackResponse,
  SubmitFeedbackParams
>(
  'feedback/submit',
  async ({ feedback }) => {
    console.log('[Feedback] Submitting feedback...');

    const response = await apiFetch('/api/feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(feedback)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`[Feedback] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to submit feedback: ${response.status}`);
    }

    const result: SubmitFeedbackResponse = await response.json();
    console.log('[Feedback] Successfully submitted');
    
    return result;
  }
);
